import { BallType } from '../../../enums/machine.enums';
import { BuildPriority } from '../../../enums/pitches.enums';
import { Nullable } from '../../common/i-generics';
import { IMachineHardwareConfig } from '../../i-machine';
import { ITrackmanHit, ITrackmanPitch } from '../../trackman/i-ball';
import { IVisionShot } from '../../training/i-msbs-shot';
import { IRapsodoShot } from '../../training/i-rapsodo-shot';
import { ICustomSpins } from '../i-custom';

type YesNo = 'Y' | 'N';

export interface ITrajektData extends Partial<ICustomSpins> {
  MachineID: Nullable<string>;
  Nickname: Nullable<string>;

  Session: Nullable<string>;
  Date: Nullable<string>;
  Timestamp: Nullable<string>;

  // from msbs
  TimeOfPitchUTC: Nullable<string>;

  ShotNumber: Nullable<number>;

  BallType: Nullable<BallType>;
  BuildPriority: Nullable<BuildPriority>;

  InGame: Nullable<YesNo>;

  Training: Nullable<YesNo>;

  /** opposite of fire.data.rejected flag */
  Valid: Nullable<YesNo>;

  /** contains fire.data.rejected_msg */
  ErrorMsg: Nullable<string>;

  PitchList: Nullable<string>;

  TargetPlateX: Nullable<number>;

  TargetPlateZ: Nullable<number>;

  /** vertical break */
  TargetVB: Nullable<number>;

  /** horizontal break */
  TargetHB: Nullable<number>;

  /** vertical break */
  ActualVB: Nullable<number>;

  /** horizontal break */
  ActualHB: Nullable<number>;

  Hitter: Nullable<string>;

  // Custom ID from user
  HitterID: Nullable<string>;

  // from mlb
  HitterPlayerPk: Nullable<number>;
}

export interface ITrackingData {
  /** if rapsodo data exists, whether pitch strike pos side, strike pos height, and spin have full confidence */
  Validated: Nullable<YesNo>;
  PITCH_GyroDegree: Nullable<number>;
  PITCH_HBSpin: Nullable<number>;
  PITCH_HBTrajectory: Nullable<number>;
  PITCH_HorizontalAngle: Nullable<number>;
  PITCH_PlayerID: Nullable<number>;
  PITCH_ReleaseExtension: Nullable<number>;
  PITCH_ReleaseHeight: Nullable<number>;
  PITCH_ReleaseSide: Nullable<number>;
  PITCH_ReleaseTime: Nullable<number>;
  PITCH_Speed: Nullable<number>;
  PITCH_SpinAxis: Nullable<number>;
  PITCH_SpinX: Nullable<number>;
  PITCH_SpinY: Nullable<number>;
  PITCH_SpinZ: Nullable<number>;
  PITCH_SpinEfficiency: Nullable<number>;
  PITCH_Strike: Nullable<boolean>;
  PITCH_StrikeZoneHeight: Nullable<number>;
  PITCH_StrikeZoneSide: Nullable<number>;
  PITCH_StrikeZoneTime: Nullable<number>;
  PITCH_TotalSpin: Nullable<number>;
  PITCH_TrueSpin: Nullable<number>;
  PITCH_VBSpin: Nullable<number>;
  PITCH_VBTrajectory: Nullable<number>;
  PITCH_VerticalAngle: Nullable<number>;
  PITCH_ZoneTime: Nullable<number>;
  HIT_Distance: Nullable<number>;
  HIT_LaunchAngle: Nullable<number>;
  HIT_ExitSpeed: Nullable<number>;
}

export const EMPTY_TRACKING_DATA: ITrackingData = {
  Validated: null,
  PITCH_GyroDegree: null,
  PITCH_HBSpin: null,
  PITCH_HBTrajectory: null,
  PITCH_HorizontalAngle: null,
  PITCH_PlayerID: null,
  PITCH_ReleaseExtension: null,
  PITCH_ReleaseHeight: null,
  PITCH_ReleaseSide: null,
  PITCH_ReleaseTime: null,
  PITCH_Speed: null,
  PITCH_SpinAxis: null,
  PITCH_SpinX: null,
  PITCH_SpinY: null,
  PITCH_SpinZ: null,
  PITCH_SpinEfficiency: null,
  PITCH_Strike: null,
  PITCH_StrikeZoneHeight: null,
  PITCH_StrikeZoneSide: null,
  PITCH_StrikeZoneTime: null,
  PITCH_TotalSpin: null,
  PITCH_TrueSpin: null,
  PITCH_VBSpin: null,
  PITCH_VBTrajectory: null,
  PITCH_VerticalAngle: null,
  PITCH_ZoneTime: null,
  HIT_Distance: null,
  HIT_LaunchAngle: null,
  HIT_ExitSpeed: null,
};

/** determines the columns in the CSV export file */
export interface ICombinedData {
  Trajekt: ITrajektData;
  Tracking: Partial<ITrackingData>;
  // only for super admin exports
  Hardware?: IMachineHardwareConfig;

  DebugRapsodo?: IRapsodoShot;
  DebugTrackmanPitch?: ITrackmanPitch;
  DebugTrackmanHit?: ITrackmanHit;
  DebugVision?: Partial<IVisionShot>;
}
